import { dateToSeconds } from "../../utils/DateTimeUtils";
import { globalDexieDb } from "../DexiedbLib";
import _ from 'lodash';
const TeleMessage = {
    id: 149104,
    chatId: "6190326403",
    isOutgoing: false,
    content: {
        text: {
            text: "ok em",
        },
    },
    date: 1708346765,
    senderId: "739839273",
    views: undefined,
    forwards: undefined,
    isScheduled: false,
    isFromScheduled: false,
    isSilent: false,
    isPinned: false,
    reactions: undefined,
    emojiOnlyCount: undefined,
    inlineButtons: undefined,
    isProtected: false,
    isForwardingAllowed: true,
    parsed: false,
}
function NewTeleMessage(): typeof TeleMessage {
    return _.cloneDeep(TeleMessage);
}
export function GenerateDataForTestMb() {
    globalDexieDb.messages.clear();
    for (let i = 0; i < 100; i++) {
        const msg = NewTeleMessage()
        msg.id = i;
        msg.chatId = "6395020070";
        msg.senderId = "6395020070";
        if (i >= 50) {
            msg.chatId = "1091845418";
            msg.senderId = "1091845418";
        }
        msg.date = dateToSeconds(new Date());
        // msg.content.text.text = `tin${i + 1} :hai cua 100 con x 1n 
        //  tong chan x 13n tong le x89n kep bangx 20n kep lech x 76n
        //  tong chia 3 x 56n, day thieu x 48n day thua x 20n`
        msg.content.text.text = `tin${i + 1} :hai cua tong le x100n`
        globalDexieDb.messages.add(msg);
    }
}